import axios from 'axios';

const getUser = () => axios.get('/user');
const aceitarTermo = () => axios.put('/user/aceitar-termo', {});
const getContext = () => axios.get('/user/context');
const list = (params) => axios.get('/user', { params });
const remove = (id) => axios.delete(`/user/${id}`, {});
const create = (user) => axios.post('/user', user);
const update = (id, user) => axios.put(`/user/${id}`, user);
const save = (user) => {
  if (user.id) {
    return update(user.id, user);
  }
  return create(user);
};

export default {
  getUser,
  aceitarTermo,
  getContext,
  create,
  update,
  save,
  list,
  remove,
};
